import CC from "components/Stacker/constants/CartConstants"
import React from "react"
import ReactDOM from "react-dom"
import { createRoot } from "react-dom/client"
import AppRoute from "AppRoute"
import { Provider } from "react-redux"
import { getStoreInstance } from "store"
import retargetEvents from "react-shadow-dom-retarget-events"
import { StackerContext } from "components/DYStackers/StackerContext"
import {
  AppStartEvent,
  AddToCartEvent,
  AddToCartCompletedEvent,
  ItemStackedEvent,
  SelectionReviewedEvent,
  ItemsUnstackedEvent,
  ShareThisClickedEvent,
} from "components/DYStackers/events"
import { BrowserRouter as Router } from "react-router-dom"

import { getQueryProducts } from "components/DYStackers/getQueryProducts"
import { AddVimeoScript } from "components/Stacker/components/Common/IntroCarousel/IntroCarouselVideo"
// import "stylesheets/vendor_global_bundle.css"
// import "stylesheets/vendor_appMain_bundle.css"
// import "stylesheets/app_main_bundle.css"
import "bootstrap/scss/bootstrap.scss"
import "stylesheets/stacker.css"
import "stylesheets/index.scss"
import "stylesheets/common/base.scss"
import "stylesheets/common/buttons.scss"
import "stylesheets/common/typography.scss"
import TypesafeI18n from "i18n/i18n-react"
import { loadAllLocales, loadLocale } from "i18n/i18n-util.sync"
import LegacyI18n from "components/DYStackers/LegacyI18n"
import DYApp from "./DYApp"
import BodyPage from "components/BodyPage"
import { App } from "testing/App"

//loadAllLocales()
loadLocale("en")
loadLocale("es")
loadLocale("fr")

const mainStore = getStoreInstance()

export class StackerElement extends HTMLElement {
  get appStores() {
    return { mainStore }
  }
  get scriptVersion() {
    return process.env.REACT_APP_SCRIPT_VERSION
  }
  get scriptParent() {
    return process.env.REACT_APP_SCRIPT_PARENT
  }
  set amuletRoute(val) {
    val
      ? this.setAttribute("amulet-route", val)
      : this.removeAttribute("amulet-route")
  }
  get amuletRoute() {
    return (
      this.getAttribute("amulet-route") || null // "/amulet-stacker/amulet-stacker.html"
    )
  }
  set braceletRoute(val) {
    val
      ? this.setAttribute("bracelet-route", val)
      : this.removeAttribute("bracelet-route")
  }
  get braceletRoute() {
    return (
      this.getAttribute("bracelet-route") || null // "/bracelet-stacker/bracelet-stacker.html"
    )
  }

  get onAddToCartEventName() {
    return this.getAttribute("dy-add-to-cart-event") || "dy-add-to-cart"
  }
  get onAppStartEventName() {
    return this.getAttribute("dy-app-start-event") || "dy-app-start"
  }
  get onAddToCartCompletedEventName() {
    return (
      this.getAttribute("dy-add-to-cart-completed-event") ||
      "dy-add-to-cart-completed"
    )
  }
  get onItemStackedEventName() {
    return this.getAttribute("dy-item-stacked-event") || "dy-item-stacked"
  }
  get onItemsUnstackedEventName() {
    return this.getAttribute("dy-items-unstacked-event") || "dy-items-unstacked"
  }
  get onSelectionReviewedEventName() {
    return (
      this.getAttribute("dy-selection-reviewed-event") ||
      "dy-selection-reviewed"
    )
  }
  get onShareThisClickedEventName() {
    return (
      this.getAttribute("dy-share-this-clicked-event") ||
      "dy-share-this-clicked"
    )
  }
  get retailerId() {
    return this.getAttribute("retailer-id") || ""
  }
  get appStore() {
    return mainStore
  }
  get gender() {
    return this.getAttribute("gender") || "women"
  }
  onAppStart(products) {
    console.log("dispatchEvent", this.onAppStartEventName, products)
    this.dispatchEvent(
      new AppStartEvent(
        this.onAppStartEventName,
        { bubbles: true },
        products,
        () => console.log("appStart done")
      )
    )
  }

  onAddToCartCompleted() {
    this.dispatchEvent(
      new AddToCartCompletedEvent(
        this.onAddToCartCompletedEventName,
        { bubbles: true },
        () => console.log("addToCartCompleted done")
      )
    )
  }

  onItemStacked(item) {
    this.dispatchEvent(
      new ItemStackedEvent(
        this.onItemStackedEventName,
        { bubbles: true },
        item,
        () => console.log("on item stacked done")
      )
    )
  }

  onItemsUnstacked(items) {
    this.dispatchEvent(
      new ItemsUnstackedEvent(
        this.onItemsUnstackedEventName,
        { bubbles: true },
        items,
        () => console.log("on items unstacked done")
      )
    )
  }

  onSelectionReviewed() {
    this.dispatchEvent(
      new SelectionReviewedEvent(
        this.onSelectionReviewedEventName,
        { bubbles: true },
        getQueryProducts().products,
        () => console.log("selected reviewed done")
      )
    )
  }

  onShareThisClicked({ shareLink, products }) {
    this.dispatchEvent(
      new ShareThisClickedEvent(
        this.onShareThisClickedEventName,
        { bubbles: true },
        shareLink,
        products,
        () => console.log("share this clicked done")
      )
    )
  }

  createDoneHandler(pid) {
    return (err) => {
      if (err) {
        mainStore.dispatch({
          type: CC.CART_DETAILS_FAILED,
          payload: err?.message || `${err}`,
          pid,
        })
      } else {
        mainStore.dispatch({
          type: CC.CART_RESET_ERROR,
        })
      }
      this.onAddToCartCompleted()
    }
  }

  onAddToCart({ sku, quantity, pid }) {
    mainStore.dispatch({
      type: CC.CART_RESET_ERROR,
      pid,
    })
    const state = mainStore.getState()
    const retailerProducts = state.retailer.retailerProducts
    //const skuid = state.pdp[sku].selectedVariant.skuid
    //const retailerProduct = retailerProducts.find(rp => rp.dy_sku === skuid)
    const retailerProduct = retailerProducts.find((rp) => rp.dySku === sku)
    this.dispatchEvent(
      new AddToCartEvent(
        this.onAddToCartEventName,
        { bubbles: true },
        retailerProduct.sku,
        quantity,
        this.createDoneHandler(pid)
      )
    )
  }

  initializeNodes = (rootNode) => {
    //TODO: WIP
    const body = rootNode.querySelector("body")

    // body > div#stacker-root > main

    const divStackerRoot = document.createElement("div")
    divStackerRoot.id = "stacker-root"
    divStackerRoot.className = "stacker-root"
    divStackerRoot.style.display = "flex"
    divStackerRoot.style.flexDirection = "column"
    divStackerRoot.style.height = "100%"

    const main = document.createElement("main")
    main.id = "mainContentArea"
    main.className = "bg-gray"
    main.style.flex = "1 1 0px"

    divStackerRoot.appendChild(main)

    // Font styles must be appended to the outer document
    const fontStyles = document.createElement("style")
    fontStyles.innerHTML = `
@font-face {
  font-family: 'slick';
  font-weight: normal;
  font-style: normal;
  src: url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/fonts/slick.eot) format("embedded-opentype"),
    url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/fonts/slick.woff) format("woff"),
    url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/fonts/lick.ttf) format("truetype"),
    url(https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/fonts/slick.svg) format("svg");
}
    `

    const outerHead = document.querySelector("head")
    outerHead.appendChild(fontStyles)
    body.appendChild(divStackerRoot)
  }

  static initializeNoShadow = () => {
    // Attach to a new node
    this.display = "none"
    const mainElement = document.createElement("main")
    mainElement.id = "mainContentArea"
    mainElement.className = "bg-gray"
    mainElement.style.flex = "1 1 0px"
    const reactTarget = document.createElement("section")
    reactTarget.id = "app-root"
    reactTarget.className = "main-stacker"
    mainElement.appendChild(reactTarget)
    this.parentNode.appendChild(mainElement)
    var root = createRoot(reactTarget)
    root.render(
      <DYApp
        lang={"en"}
        store={mainStore}
        retailerId={this.retailerId}
        gender="{this.gender}"
      >
        <section id={"app-root"} className={"main-stacker"}>
          <Router>
            <AppRoute />
          </Router>
        </section>
      </DYApp>
    )
    // ReactDOM.render(
    //   <Provider store={mainStore}>
    //     <StackerContext.Provider
    //       value={{
    //         getInstance: () => this,
    //         retailerId: this.retailerId,
    //       }}
    //     >
    //       <section id={"app-root"} className={"main-stacker"}>
    //         <Router navigator={history}>
    //           <AppRoute />
    //         </Router>
    //       </section>
    //     </StackerContext.Provider>
    //   </Provider>,
    //   reactTarget
    // )
    return
  }

  constructor() {
    super()
    this.initializeNodes(this.shadowRoot)
    console.log(`StackerElement initialized`, {
      amuletRoute: this.amuletRoute,
      braceletRoute: this.braceletRoute,
      shadow: !("" + window.location.search).includes("noshadow"),
    })
    // TODO: this is a work in progress
    if (("" + window.location.search).includes("noshadow")) {
      StackerElement.initializeNoShadow()
      return
    }
    StackerElement.initialize(this)
    StackerElement.appStart(this)
  }

  static async appStart(instance) {
    // Give JavaScript code a chance to execute and subscribe to this event
    await new Promise((resolve) =>
      window.requestAnimationFrame(() => resolve())
    )
    instance.onAppStart(getQueryProducts().allCodes)
  }

  static initialize(instance) {
    const testStacker = document.getElementById("teststacker")
    const shadowRoot =
      instance.shadowRoot || instance.attachShadow({ mode: "open" })
    const reactRoot = shadowRoot.querySelector("#mainContentArea")
      ? shadowRoot.querySelector("#mainContentArea")
      : document.getElementById("mainContentArea")
    instance.id = "mainContentArea"
    instance.style.flex = "1 1 0"
    instance.className = "bg-white " + instance.gender

    const hostMode = (
      //<React.StrictMode>
      <TypesafeI18n locale="en">
        <Provider store={mainStore}>
          <StackerContext.Provider
            value={{
              getInstance: () => instance,
              retailerId: instance.retailerId,
              lang: "en",
              gender: instance.gender,
            }}
          >
            <LegacyI18n>
              <section id={"app-root"} className={"main-stacker"}>
                <Router>
                  <AppRoute />
                </Router>
              </section>
            </LegacyI18n>
          </StackerContext.Provider>
        </Provider>
      </TypesafeI18n>
      //</React.StrictMode>
    )

    const testMode = (
      <DYApp
        lang={"en"}
        store={mainStore}
        retailerId={"SMITH"}
        context={instance}
        gender={"women"}
      >
        <LegacyI18n>
          <BodyPage>
            <App />
          </BodyPage>
        </LegacyI18n>
      </DYApp>
    )

    if (!testStacker) {
      console.log("host mode")
      const root = createRoot(reactRoot)
      root.render(hostMode)
    } else {
      console.log("test mode")
      const root = createRoot(reactRoot)
      root.render(testMode)
    }
    AddVimeoScript({ element: shadowRoot })
    //console.log("retarget events ..."); // TODO: if we can upgrade to React 17 this is not needed?
    //retargetEvents(shadowRoot)
  }
}

if (!window.customElements.get("dy-stackers")) {
  // Avoid hot reload, etc. from breaking
  window.customElements.define("dy-stackers", StackerElement)
}
